import React, {useState} from 'react';
import {
    AutoComplete, Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Radio,
    Row,
    Select,
    Space,
    Typography
} from "antd";
import {currencyFormatter, currencyParser} from "../../../../../assets/scripts/parser-functions";
import {Geo} from "aws-amplify";
import countries from "../../../../../assets/scripts/countries.json";
import {DeleteOutlined, MinusCircleOutlined, PlusOutlined, SaveOutlined} from "@ant-design/icons";

const {TextArea} = Input;

function Address(props) {
    const minWords = 2
    const maxWords = 5
    const [state, setState] = useState({
        options: [],
        fetching: false,
        string: ''
    })

    const [options, setOptions] = useState([]);
    const [fetching, setFetching] = useState(false);
    const onSelect = (data) => {

    };
    const onSearch = (text) => {
        setState(prev => ({...prev, string: text}))
        if (!state.fetching) {
            const noResults = !state.options.filter(address => address.value.startsWith(text)).length
            if (noResults) {
                const words = text.split(" ");
                if (words.length > minWords && words.length < maxWords) {
                    getItems(text)
                }
            }
        }

    }
    const getItems = async (v) => {
        setState(prev => ({...prev, fetching: true}))

        const results = await Geo.searchByText(v, {
            countries: ["IRL"], // Alpha-3 country codes
            maxResults: 50, // 50 is the max and the default
        })
        const opts = results.map(item => ({value: item.label}))
        setState(prev => ({...prev, fetching: false, options: opts}))
    }
    return <AutoComplete
        {...props}
        options={state.options.filter(opt => opt.value.startsWith(state.string))}
        onSelect={onSelect}
        onSearch={onSearch}
    />
}

function DOBArray({id, ...props}) {

    return <Form.Item
        {...props}
        noStyle
        shouldUpdate={(prevValues, currentValues) => {
            return prevValues.countDependents !== currentValues.countDependents
        }}
    >
        {({getFieldValue}) => {
            return (
                <>
                <Form.List
                    name={id}
                >
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <Space key={key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                                    <Form.Item
                                        {...restField}
                                        name={name}
                                    >
                                        <DatePicker format="D MMM YYYY" />
                                    </Form.Item>
                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                </Space>
                            ))}
                            <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                    Add Dependent DOB
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
                <Button
                    type="dashed"
                    onClick={()=>{
                        props.onBlur()
                    }}
                    block
                    icon={<SaveOutlined />}
                >
                        Save DOB Changes
                </Button>
                </>
            )
        }}

    </Form.Item>

}

export function DateString(props) {
    function formatDate(str) {
        const correctDay = (str, moreParts) => {
            if (str.length === 1) {
                if (moreParts || parseInt(str) > 3) {
                    str = '0' + str
                }
            }
            if (parseInt(str) > 31) {
                str = str.slice(0, -1)
            }
            return str
        }
        const correctMonth = (str, moreParts) => {
            if (str.length === 1) {
                if (moreParts || parseInt(str) > 1) {
                    str = '0' + str
                }
            }
            if (parseInt(str) > 12) {
                str = str.slice(0, -1)
            }
            return str
        }
        const correctYear = (str) => {
            const maxYear = ((new Date()).getFullYear() + 49).toString().slice(0, -1)
            // detect and correct YY format to YYYY
            if ([5, 6, 7, 8, 9].includes(parseInt(str))) {
                str = 190 + parseInt(str)
            }
            if ([0].includes(parseInt(str))) {
                str = 200 + parseInt(str)
            }
            str = str.toString()
            // prevent starting a year incorrectly
            if (
                (str.length === 1 && ![1, 2].includes(parseInt(str))) ||
                (str.length === 2 && ![19, 20].includes(parseInt(str))) ||
                (str.length === 3 && (parseInt(str) < 195 || parseInt(str) > maxYear))) {
                str = str.slice(0, -1)
            }
            return str
        }
        const parts = str.split('/').map(item => item.trim())
        const newParts = parts.map((part, i) => {
            if (props?.noDays) {
                if (i === 0) {
                    return correctMonth(part, parts.length > 1)
                }
                if (i === 1) {
                    return correctYear(part)
                }
            } else {
                if (i === 0) {
                    return correctDay(part, parts.length > 1)
                }
                if (i === 1) {
                    return correctMonth(part, parts.length > 2)
                }
                if (i === 2) {
                    return correctYear(part)
                }
            }
        })
        // add next part when part is completed
        if ((newParts.length === 1 && newParts[0].length === 2)) {
            newParts.push('')
        }
        if (!props?.noDays) {
            if (newParts.length === 2 && newParts[1].length === 2) {
                newParts.push('')
            }
        }
        return newParts.join(' / ')
    }

    let {noDays, ...other} = props
    let elementProps = {...other}
    elementProps.onKeyPress = function (e) {
        let maxLength = props?.noDays ? 9 : 14
        if (e.key === 'Backspace' || e.keyCode === 8) {
            return true
        }

        if (e.target.value.length >= maxLength) {
            e.preventDefault()
            return false
        }

        //if the cursor is at the end of the field, format to a date like string
        if (e.target.value.length === e.target.selectionStart && e.target.selectionEnd - e.target.selectionStart === 0) {
            e.preventDefault()

            const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
            const charStr = String.fromCharCode(charCode);

            // prevent if not a digit or slash
            if (!(/\d/.test(charStr)) && charStr !== '/') {
                return false
            }

            let orig = e.target.value

            // if slash, make sure there isn't a previous one
            if (charStr === '/' && orig.trimRight().endsWith('/')) {
                return false
            }

            const temp = orig + '' + charStr

            //only allow a slash if the day or month is 1 char len
            // if (charStr === '/') {
            //     //if ([1, 7].includes(orig.length)) {
            //         formatDate(temp)
            //    // } else {
            //    //     return false
            //    // }
            // }
            e.target.value = formatDate(temp)
            props.onChange(e)
            return true
        }

    }
    elementProps.placeholder = props?.noDays ? 'MM / YYYY' : 'DD / MM / YYYY'
    // if (!elementProps.hasOwnProperty('style')){
    //     elementProps.style={}
    // }
    // elementProps.style.width='100%'
    return (<Input {...elementProps} />)
}

function Phone(props) {
    const prefix = ['0402', '0404', '0504', '0505', '01', '071', '074', '083', '085', '086', '087', '089', '090']
    const array = ['2', '4', '5', '6', '9']
    array.forEach(secondDigit => {
        let i = 1
        while (i < 10) {
            let newPfx = `0${secondDigit}${i}`
            if (!['092', '054', '055'].includes(newPfx)) {
                prefix.push(newPfx)
            }
            i += 1
        }
    })
    let onKeyPress = function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            return e.target.blur()
        }
        if (e.key === 'Backspace' || e.keyCode === 8) {
            return
        }

        const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        const charStr = String.fromCharCode(charCode);
        const digit = (/\d/.test(charStr) || ['(', ')', '-'].includes(charStr))
        if (!digit) return

        // if the cursor is at the end of the field, format to a date like string
        if (e.target.value.length === e.target.selectionStart && e.target.selectionEnd - e.target.selectionStart === 0) {
            let orig = e.target.value
            const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
            const charStr = String.fromCharCode(charCode);
            let temp = orig + '' + charStr
            if (temp === '00') {
                e.preventDefault()
                e.target.value = "+"
                return
            }
            if (prefix.includes(temp)) {
                e.preventDefault()
                temp = `(${temp}) `
                e.target.value = temp
                return
            }

            const dashLen = temp.includes('(01)') ? 8 : 9
            const l = temp.split('')
            if (l.includes('(') && l.includes(')') && l.length === dashLen) {
                e.preventDefault()
                e.target.value = `${temp}-`
                return
            }
        }
    }
    return (<Input {...props} onKeyPress={onKeyPress}/>)
}

function Country(props) {
    let keyName = props?.nationality ? "nationality" : "en_short_name"
    let options = countries.map(item => {
        return {
            label: item[keyName],
            value: item.alpha_2_code
        }
    })
    let {nationality, ...other} = props
    return <Select
        showSearch
        {...other}
        options={options}
        optionFilterProp="children"
        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
        filterSort={(optionA, optionB) =>
            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
        }
    />
}

export function fakeForm(vars) {
    return {
        getFieldValue: (name) => {
            return vars[name]
        }
    }
}

// Health inputs, copied from the legacy user app (FormItemInput.js)
// A choice marked `exclusive` (e.g. "None of these") can't be combined with any other -
// ticking it clears the rest, ticking anything else clears it
function MultiChoiceGroup({choices, value, onChange}) {
    const selectedValues = Array.isArray(value) ? value : []
    const exclusiveValues = choices.filter(choice => choice.exclusive).map(choice => choice.value)
    const handleChange = nextValues => {
        const added = nextValues.find(item => !selectedValues.includes(item))
        if (added !== undefined && exclusiveValues.includes(added)) {
            onChange([added])
            return
        }
        onChange(added !== undefined ? nextValues.filter(item => !exclusiveValues.includes(item)) : nextValues)
    }
    // long choice texts get a full row each
    const span = choices.some(choice => `${choice.text}`.length > 40) ? 24 : 12
    return <Checkbox.Group style={{display: 'flex', flexDirection: 'column'}} value={selectedValues} onChange={handleChange}>
        <Row>
            {
                choices.map(item => <Col span={span} style={{marginBottom: 3}} key={item.value}>
                    <Checkbox size='large' value={item.value}>{item.text}</Checkbox>
                </Col>)
            }
        </Row>
    </Checkbox.Group>
}

// Cover wanted, for the legacy app's legacyPolicyConfig. Value: {seriousIllnessIncluded,
// seriousIllnessAmount, incomeProtectionIncluded, incomeProtectionAmount} - each
// amount only kept while its cover is included
function PolicyConfig({answer, value, onChange}) {
    const config = value && typeof value === 'object' ? value : {}
    const covers = [
        {included: 'seriousIllnessIncluded', amount: 'seriousIllnessAmount', ...answer.seriousIllness},
        {included: 'incomeProtectionIncluded', amount: 'incomeProtectionAmount', ...answer.incomeProtection},
    ]
    const setIncluded = (cover, included) => onChange({
        ...config,
        [cover.included]: included,
        [cover.amount]: included ? config[cover.amount] : null,
    })
    return <Space direction="vertical" size="middle" style={{width: '100%'}}>
        {covers.map(cover => <Space key={cover.included} direction="vertical" size="small" style={{width: '100%'}}>
            <Typography.Text strong>{cover.question}</Typography.Text>
            <Radio.Group
                value={config[cover.included]}
                onChange={event => setIncluded(cover, event.target.value)}
                style={{display: 'flex', width: '100%'}}
            >
                <Radio.Button style={{flex: 1}} value={true}>Yes</Radio.Button>
                <Radio.Button style={{flex: 1}} value={false}>No</Radio.Button>
            </Radio.Group>
            {config[cover.included] === true && <InputNumber
                inputMode="decimal"
                pattern="[0-9,]*"
                addonBefore={"€"}
                precision={0}
                min={0}
                formatter={currencyFormatter}
                parser={currencyParser}
                placeholder={cover.amountLabel}
                value={config[cover.amount]}
                onChange={amount => onChange({...config, [cover.amount]: amount})}
                style={{width: '100%'}}
            />}
        </Space>)}
    </Space>
}

// Family medical history, ported from sussd-mono's family-medical-history-input.jsx.
// Value: {conditions: [value], details: {[condition]: {familyMembers: [{relationship,
// ageAtDiagnosis, ageAtDeath}], testedOrAdvised}}}. A condition marked `exclusive`
// ("No" / "Don't know") clears the rest
const emptyFamilyMember = () => ({
    relationship: undefined,
    ageAtDiagnosis: undefined,
    ageAtDeath: undefined,
})
const normaliseFamilyMedicalHistory = value => ({
    conditions: Array.isArray(value?.conditions) ? value.conditions : [],
    details: value?.details && typeof value.details === 'object' ? value.details : {},
})
const ensureConditionDetails = (details, condition) => ({
    familyMembers: details?.[condition]?.familyMembers?.length
        ? details[condition].familyMembers
        : [emptyFamilyMember()],
    testedOrAdvised: details?.[condition]?.testedOrAdvised,
})

function FamilyMedicalHistory({answer, value, onChange}) {
    const selectedValue = normaliseFamilyMedicalHistory(value)
    const {conditions, relationships, testedOptions, testedQuestion} = answer
    const conditionByValue = condition => conditions.find(option => option.value === condition)
    const isExclusive = condition => Boolean(conditionByValue(condition)?.exclusive)
    const selectedMedicalConditions = selectedValue.conditions.filter(condition => !isExclusive(condition))

    const setValue = nextValue => onChange({
        conditions: nextValue.conditions ?? [],
        details: nextValue.details ?? {},
    })

    const updateConditions = nextConditions => {
        const added = nextConditions.filter(condition => !selectedValue.conditions.includes(condition))
        const addedExclusive = added.find(isExclusive)
        if (addedExclusive) {
            setValue({conditions: [addedExclusive], details: {}})
            return
        }
        const cleanConditions = nextConditions.filter(condition => !isExclusive(condition))
        setValue({
            conditions: cleanConditions,
            details: cleanConditions.reduce((details, condition) => ({
                ...details,
                [condition]: ensureConditionDetails(selectedValue.details, condition),
            }), {}),
        })
    }

    const updateConditionDetails = (condition, nextDetails) => setValue({
        conditions: selectedValue.conditions,
        details: {...selectedValue.details, [condition]: nextDetails},
    })

    const updateFamilyMember = (condition, memberIndex, field, nextFieldValue) => {
        const conditionDetails = ensureConditionDetails(selectedValue.details, condition)
        updateConditionDetails(condition, {
            ...conditionDetails,
            familyMembers: conditionDetails.familyMembers.map((member, index) => (
                index === memberIndex ? {...member, [field]: nextFieldValue} : member
            )),
        })
    }

    const addFamilyMember = condition => {
        const conditionDetails = ensureConditionDetails(selectedValue.details, condition)
        updateConditionDetails(condition, {
            ...conditionDetails,
            familyMembers: [...conditionDetails.familyMembers, emptyFamilyMember()],
        })
    }

    const removeFamilyMember = (condition, memberIndex) => {
        const conditionDetails = ensureConditionDetails(selectedValue.details, condition)
        const nextFamilyMembers = conditionDetails.familyMembers.filter((_, index) => index !== memberIndex)
        updateConditionDetails(condition, {
            ...conditionDetails,
            familyMembers: nextFamilyMembers.length ? nextFamilyMembers : [emptyFamilyMember()],
        })
    }

    return <Space direction="vertical" size="middle" style={{width: '100%'}}>
        <Checkbox.Group
            onChange={updateConditions}
            options={conditions.map(({label, value}) => ({label, value}))}
            style={{display: 'grid', gap: 8}}
            value={selectedValue.conditions}
        />

        {selectedMedicalConditions.map(condition => {
            const conditionDetails = ensureConditionDetails(selectedValue.details, condition)
            return <Card key={condition} size="small" title={<Typography.Text strong>{conditionByValue(condition)?.label ?? condition}</Typography.Text>}>
                <Space direction="vertical" size="middle" style={{width: '100%'}}>
                    <Space direction="vertical" size="small" style={{width: '100%'}}>
                        {conditionDetails.familyMembers.map((member, index) => (
                            <Row gutter={[8, 8]} key={`${condition}-${index}`}>
                                <Col xs={24} md={7}>
                                    <Select
                                        aria-label="Relationship"
                                        onChange={nextValue => updateFamilyMember(condition, index, 'relationship', nextValue)}
                                        options={relationships}
                                        placeholder="Relationship"
                                        style={{width: '100%'}}
                                        value={member.relationship}
                                    />
                                </Col>
                                <Col xs={24} md={7}>
                                    <InputNumber
                                        aria-label="Age at diagnosis"
                                        max={59}
                                        min={0}
                                        onChange={nextValue => updateFamilyMember(condition, index, 'ageAtDiagnosis', nextValue)}
                                        placeholder="Age at diagnosis"
                                        style={{width: '100%'}}
                                        value={member.ageAtDiagnosis}
                                    />
                                </Col>
                                <Col xs={24} md={8}>
                                    <InputNumber
                                        aria-label="Age at death if applicable"
                                        max={59}
                                        min={0}
                                        onChange={nextValue => updateFamilyMember(condition, index, 'ageAtDeath', nextValue)}
                                        placeholder="Age at death, if applicable"
                                        style={{width: '100%'}}
                                        value={member.ageAtDeath}
                                    />
                                </Col>
                                <Col xs={24} md={2}>
                                    <Button
                                        aria-label="Remove family member"
                                        icon={<DeleteOutlined/>}
                                        onClick={() => removeFamilyMember(condition, index)}
                                    />
                                </Col>
                            </Row>
                        ))}
                    </Space>

                    <Button icon={<PlusOutlined/>} onClick={() => addFamilyMember(condition)} type="dashed">
                        Add another family member with this condition
                    </Button>

                    <Space direction="vertical" size="small">
                        <Typography.Text strong type="secondary">{testedQuestion}</Typography.Text>
                        <Radio.Group
                            onChange={event => updateConditionDetails(condition, {
                                ...conditionDetails,
                                testedOrAdvised: event.target.value,
                            })}
                            optionType="button"
                            options={testedOptions}
                            value={conditionDetails.testedOrAdvised}
                        />
                    </Space>
                </Space>
            </Card>
        })}
    </Space>
}

function SectionQuestion(props) {

    const renderLabel = (question, f) => {
        // e.g. when the label is shown in a table column instead
        if (props.hideLabel) return undefined
        let t = question.text
        if (typeof question.text === 'function') {
            t = question.text(f)
        }
        return <div key={t} style={{display: 'flex', flexDirection: 'column'}}>
            <Typography.Text style={{margin: 0}}>{question.label}</Typography.Text>
            {/*<Typography>{t}</Typography>*/}
        </div>
    }
    const renderQuestion = (question, f) => {
        if (Array.isArray(question)) {
            return (
                <div className="d-row gap-9 j-equal">

                    {question.map((q, i) => renderQuestion(q, f))}

                </div>
            )
        }

        let rules = question.rules
        if (typeof question.rules === "function") {
            rules = question.rules(f)
        }
        let disabled = !!question.answer.disabled
        switch (question.answer.type) {
            case 'weight':
                return <Form.Item
                    className="mb-3" key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                    validateFirst
                    onBlur={handleOnBlur}
                >
                    <InputNumber addonAfter={"kg"} precision={1} style={{width: '100%'}} onBlur={handleOnBlur}/>
                </Form.Item>
            case 'height':
                return <Form.Item
                    className="mb-3" key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                    validateFirst
                    onBlur={handleOnBlur}
                >
                    <InputNumber addonAfter={"cm"} precision={1} style={{width: '100%'}} onBlur={handleOnBlur}/>
                </Form.Item>
            case 'phone':
                return <Form.Item
                    className="mb-3" key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                    validateFirst
                    onBlur={handleOnBlur}
                >
                    <Phone
                        precision={0}
                    />
                </Form.Item>
            case 'euro':
                return <Form.Item
                    className="mb-3" key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    //tooltip="Enter the value/price of the property"
                    rules={rules}
                    validateFirst
                >

                    {props.inExtWindow ? <Input addonBefore={"€"}
                                                style={{width: '100%'}}
                                                onBlur={handleOnBlur}/> : <InputNumber
                        addonBefore={"€"}
                        precision={0}
                        formatter={currencyFormatter}
                        parser={currencyParser}
                        style={{width: '100%'}}
                        onBlur={handleOnBlur}
                    />}
                </Form.Item>
            case 'int':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}

                >
                    <InputNumber
                        precision={0}
                        style={{width: '100%'}}
                        onBlur={handleOnBlur}
                    />
                </Form.Item>
            case 'float':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <InputNumber
                        precision={2}
                        style={{width: '100%'}}
                        onBlur={handleOnBlur}
                    />
                </Form.Item>
            case 'text':
                // Somewhere along the line, question.answer.type is overwritten when is asArray=false
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    {props?.question?.answer?.hasOwnProperty('asArray') ? <TextArea onBlur={handleOnBlur}/> :<Input
                        onBlur={handleOnBlur}
                        style={{width: '100%'}}
                    /> }

                </Form.Item>
            case 'gifters':

                return (


                    <Form.List name={question.name}>
                        {(fields, {add, remove}) => (
                            <>
                                {fields.map(({key, name, ...restField}) => (
                                    <Space key={key} style={{display: 'flex', marginBottom: 8}} align="baseline">
                                        <Form.Item
                                            className="mb-0"
                                            {...restField}
                                            name={[name, 'fullName']}
                                            rules={[{required: true, message: 'Missing full name'}]}
                                        >
                                            <Input placeholder="Full Name"/>
                                        </Form.Item>
                                        <Form.Item
                                            className="mb-0"
                                            {...restField}
                                            name={[name, 'relationship']}
                                            rules={[{required: true, message: 'Missing relationship'}]}
                                        >
                                            <Input placeholder="Relationship"/>
                                        </Form.Item>
                                        <MinusCircleOutlined onClick={() => remove(name)}/>
                                    </Space>
                                ))}
                                <Form.Item className="mb-0">
                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                        Add another gifter
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>)
            case 'choice':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <Radio.Group style={{display: 'flex', width: '100%'}}>
                        {
                            question.answer.choices.map(item => <Radio.Button onClick={handleOnBlur} style={{flex: 1}}
                                                                              value={item.value}
                                                                              key={`${question.text}${item.value}`}>{item.text}</Radio.Button>)
                        }
                    </Radio.Group>
                </Form.Item>
            case 'select':

                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    {props.inExtWindow ? <select>
                        <option></option>
                        {question.answer.choices.map(choice=>{
                            return <option value={choice.value} key={`${question.text}${choice.value}`}>{choice.text}</option>
                            })}
                    </select> :  <Select onSelect={handleOnBlur} disabled={disabled}>
                        {
                            question.answer.choices.map(item => <Select.Option
                                value={item.value} key={`${question.text}${item.value}`}>{item.text}</Select.Option>)
                        }
                    </Select> }



                </Form.Item>
            case 'address':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <Address onBlur={handleOnBlur}/>
                </Form.Item>
            case 'ddmmyyyy':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <DateString onBlur={handleOnBlur}/>
                </Form.Item>
            case 'date':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    {props.inExtWindow ? <Input format="D MMM YYYY" type="date" onBlur={handleOnBlur} placeholder="DD MMM YYYY" /> :
                    <DatePicker format="D MMM YYYY" style={{width: '100%'}} onBlur={handleOnBlur}/>}
                </Form.Item>
            case 'mmyyyy':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <DateString onBlur={handleOnBlur} noDays={true}/>
                </Form.Item>
            case 'country' :
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <Country onSelect={handleOnBlur}/>
                </Form.Item>
            case 'nationality' :
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <Country onSelect={handleOnBlur} nationality={true}/>
                </Form.Item>
            case 'textareaString':
                case 'paragraphs':
            case 'textarea':

                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <TextArea onBlur={handleOnBlur}/>
                </Form.Item>
            case 'agearray':

                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <DOBArray onBlur={handleOnBlur} question={question} id={question.name}/>
                </Form.Item>
            case 'multichoice':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <MultiChoiceGroup choices={question.answer.choices}/>

                </Form.Item>
            case 'diagnosedConditions':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <MultiChoiceGroup choices={question.answer.conditions.map(({title, value, exclusive}) => ({text: title, value, exclusive}))}/>
                </Form.Item>
            case 'familyMedicalHistory':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <FamilyMedicalHistory answer={question.answer}/>
                </Form.Item>
            case 'policyConfig':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}
                >
                    <PolicyConfig answer={question.answer}/>
                </Form.Item>
            case 'email':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid e-mail',
                        }
                    ]}>
                    <Input type="email" onBlur={handleOnBlur}/>
                </Form.Item>
            case 'datepicker':
                return <Form.Item
                    className="mb-3" validateFirst
                    key={question.text}
                    name={question.name}
                    label={renderLabel(question, f)}
                    rules={rules}

                >
                    <DatePicker
                        format="DD MMM YYYY"
                        style={{width: '100%'}}
                        onBlur={handleOnBlur}
                    />
                </Form.Item>
            default:
                return <div key={question.text}
                            style={{padding: 5, backgroundColor: 'red'}}>{question.answer.type}</div>
        }
    }
    const renderStyledQuestion = (question, f) => {
        return <div className="styler" style={props.style}>
            {renderQuestion(question, f)}
        </div>
    }
    const handleOnBlur = () => {
        props.onBlur(props.question)
    }
    if (!!props.question?.hides || typeof props.question?.text === "function" || typeof props.question?.label === "function" || typeof props.question?.rules === "function") {
        return <Form.Item
            noStyle
            shouldUpdate={true}>
            {(f) => {
                if (props.question?.hides && props.question.hides(f)) {
                    return <></>
                }
                return renderStyledQuestion(props.question, f)
            }}
        </Form.Item>
    }

    return renderStyledQuestion(props.question)
}

export default SectionQuestion;